/** FAQ, Support, and Advertising page copy (Croatian). */
export const pagesMessagesHr = {
  faq: {
    pageTitle: "Često postavljana pitanja",
    pageSubtitle: "Pronađite odgovore na česta pitanja o WasOK-u",
    seoTitle: "FAQ — WasOK",
    seoDescription:
      "Odgovori na česta pitanja o WasOK-u, skeniranju proizvoda, privatnosti i ocjenama.",
    items: [
      {
        question: "Kako funkcionira WasOK?",
        answer:
          "WasOK vam pomaže zapamtiti koji su vam se proizvodi svidjeli, a koji ne, skeniranjem barkodova te spremanjem vaših ocjena i bilješki. Jednostavno skenirajte barkod proizvoda, ocijenite ga, dodajte bilješke, a sljedeći put kad skenirate isti proizvod, odmah ćete vidjeti svoju prethodnu recenziju.",
      },
      {
        question: "Jesu li moji podaci pohranjeni u oblaku?",
        answer:
          "Ne! Svi vaši podaci pohranjeni su lokalno na vašem uređaju. Ne sinkroniziramo vaše informacije u oblak, što znači da vaša povijest kupovine i mišljenja o proizvodima ostaju u potpunosti privatni. Međutim, to također znači da biste trebali izraditi sigurnosnu kopiju uređaja ako želite sačuvati svoje podatke.",
      },
      {
        question: "Trebam li internetsku vezu za korištenje WasOK-a?",
        answer:
          "Ne, WasOK funkcionira potpuno bez interneta. Budući da su svi vaši podaci pohranjeni lokalno na vašem uređaju, možete skenirati proizvode, dodavati ocjene i pregledavati svoju povijest bez ikakve internetske veze.",
      },
      {
        question: "Mogu li WasOK koristiti za bilo koju vrstu proizvoda?",
        answer:
          "Da! WasOK funkcionira sa svakim proizvodom koji ima barkod. Bilo da je riječ o hrani, kozmetici, kućanskim potrepštinama, elektronici ili bilo čemu drugome s barkodom, možete to skenirati i spremiti svoje mišljenje.",
      },
      {
        question: "Kako skenirati barkod?",
        answer:
          "Jednostavno otvorite aplikaciju WasOK i dodirnite gumb za skeniranje. Usmjerite kameru na barkod proizvoda i aplikacija će ga automatski prepoznati i skenirati. Za najbolje rezultate pobrinite se da je barkod dobro osvijetljen i u fokusu.",
      },
      {
        question: "Mogu li dodati fotografije svojim recenzijama proizvoda?",
        answer:
          "Da! Fotografije možete priložiti bilo kojoj recenziji proizvoda. Ovo je posebno korisno za pamćenje detalja ambalaže, popisa sastojaka ili bilo koje druge vizualne informacije koja vam može pomoći da se sjetite zašto vam se proizvod svidio ili nije svidio.",
      },
      {
        question: "Koje informacije mogu spremiti o proizvodima?",
        answer:
          "Možete spremiti ocjene (1-5 zvjezdica), tekstualne bilješke, fotografije, cijenu koju ste platili, mjesto kupnje i prilagođene kategorije. Ove sveobuhvatne informacije pomažu vam donositi informirane odluke prilikom kupovine.",
      },
      {
        question: "Mogu li kreirati popise za kupovinu?",
        answer:
          "Da! WasOK vam omogućuje kreiranje popisa za kupovinu od proizvoda koje ste već recenzirali. Ovo olakšava pamćenje koji su vam se proizvodi svidjeli i koje želite ponovno kupiti.",
      },
      {
        question: "Kako organizirati svoje proizvode?",
        answer:
          "Proizvode možete organizirati pomoću prilagođenih kategorija. Na primjer, možete kreirati kategorije poput „Grickalice“, „Kava“, „Njega kože“ ili „Sredstva za čišćenje“. Ovo olakšava pregledavanje vaših recenzija po vrsti.",
      },
      {
        question: "Je li WasOK besplatan za korištenje?",
        answer:
          "Da, WasOK je potpuno besplatan za preuzimanje i korištenje. Nema kupnji unutar aplikacije, pretplata ni skrivenih naknada. Vjerujemo da bi svatko trebao imati pristup privatnom načinu pamćenja svojih preferencija o proizvodima.",
      },
      {
        question: "Je li WasOK pristupačan?",
        answer:
          "WasOK je dizajniran da bude upotrebljiv za što više ljudi. Aplikacija uključuje značajke pristupačnosti poput podrške za čitač zaslona, prilagodljivog teksta i opcionalnog načina rada s visokim kontrastom.",
      },
      {
        question: "Što se događa ako deinstaliram aplikaciju?",
        answer:
          "Budući da su svi podaci pohranjeni lokalno na vašem uređaju, deinstalacijom aplikacije izbrisat će se sve vaše recenzije proizvoda, bilješke i popisi za kupovinu. Prije deinstalacije obavezno izvezite svoje podatke ako želite zadržati sigurnosnu kopiju.",
      },
      {
        question: "Mogu li izvesti svoje podatke?",
        answer:
          "Da, WasOK vam omogućuje izvoz podataka u svrhu izrade sigurnosne kopije. Sve svoje recenzije možete izvesti u datoteku koju možete spremiti na svoj uređaj ili u cloud pohranu po vlastitom izboru.",
      },
      {
        question: "Prati li WasOK moju lokaciju?",
        answer:
          "Ne, WasOK ne prati vašu lokaciju. Iako možete ručno unijeti naziv trgovine u kojoj ste kupili proizvod, aplikacija ne koristi GPS ni usluge lokacije.",
      },
      {
        question: "Mogu li koristiti WasOK na više uređaja?",
        answer:
          "Trenutačno se WasOK ne sinkronizira između uređaja jer su svi podaci pohranjeni lokalno. Svaki će uređaj imati vlastitu zasebnu bazu podataka proizvoda i recenzija.",
      },
      {
        question: "Što ako se barkod ne skenira?",
        answer:
          "Ako se barkod ne skenira, provjerite je li dobro osvijetljen i u fokusu. Također možete pokušati očistiti objektiv kamere. Ako je barkod oštećen ili nejasan, možda ćete moći ručno unijeti broj barkoda.",
      },
    ],
    cta: {
      heading: "Imate još pitanja?",
      body: "Obratite se našem timu za podršku — rado ćemo vam pomoći.",
      button: "Kontaktirajte podršku",
    },
  },
  support: {
    pageTitle: "Podrška",
    seoTitle: "Podrška — WasOK",
    seoDescription:
      "Zatražite pomoć za WasOK: kontaktirajte podršku, prijavite greške i podijelite povratne informacije.",
    getHelp: {
      title: "Zatražite pomoć",
      body: "Tu smo da vam pomognemo iskoristiti WasOK u potpunosti. Ako imate problema ili pitanja, imamo na raspolaganju nekoliko resursa koji vam mogu pomoći.",
    },
    faq: {
      title: "Često postavljana pitanja",
      body: "Prije nego što nas kontaktirate, pogledajte naš odjeljak FAQ gdje odgovaramo na najčešća pitanja o WasOK-u. Ondje ćete pronaći detaljne informacije o tome kako aplikacija funkcionira, privatnosti, pohrani podataka i drugom.",
    },
    contact: {
      title: "Kontaktirajte podršku",
      body: "Ako ne možete pronaći odgovor koji tražite, naš tim za podršku spreman je pomoći. Možete nas kontaktirati na:",
      emailLabel: "E-pošta:",
      responseTime: "Obično odgovaramo u roku od 24-48 sati",
    },
    bugs: {
      title: "Prijava grešaka",
      body: "Pronašli ste grešku? Cijenimo vašu pomoć u poboljšanju WasOK-a. Prilikom prijave greške, molimo uključite:",
      items: [
        "Detaljan opis problema",
        "Korake za reprodukciju problema",
        "Model vašeg uređaja i verziju Androida",
        "Snimke zaslona ili snimke zaslona ako je moguće",
      ],
      sendPrefix: "Prijave grešaka pošaljite na:",
    },
    featureRequests: {
      title: "Zahtjevi za nove značajke",
      bodyBefore: "Imate ideju za novu značajku? Voljeli bismo čuti vaš prijedlog! Pošaljite ga na",
      bodyAfter:
        ". Iako ne možemo implementirati svaki zahtjev, pažljivo razmatramo sve povratne informacije prilikom planiranja budućih ažuriranja.",
    },
    knownIssues: {
      title: "Poznati problemi",
      body: "Trenutačno smo svjesni sljedećih problema i radimo na rješenjima:",
      items: [
        "Neki se barkodovi možda neće skenirati u slabim uvjetima osvjetljenja — pokušajte koristiti bljeskalicu",
        "Vrlo dugačke bilješke o proizvodu mogu potrajati malo dulje kod spremanja na starijim uređajima",
        "Sličice slika mogu izgledati pikselizirano na zaslonima visoke rezolucije",
      ],
    },
    appUpdates: {
      title: "Ažuriranja aplikacije",
      body: "Redovito objavljujemo ažuriranja s novim značajkama, poboljšanjima i ispravcima grešaka. Obavezno održavajte WasOK ažuriranim putem Google Play Storea kako biste dobili najnovija poboljšanja.",
    },
    community: {
      title: "Zajednica",
      body: "Pridružite se našoj zajednici korisnika koji donose pametnije odluke o kupovini uz WasOK. Podijelite savjete, postavljajte pitanja i povežite se s drugim korisnicima na našim društvenim mrežama.",
    },
    emergency: {
      title: "Hitna podrška",
      body: 'Ako imate kritičan problem koji vam onemogućuje korištenje aplikacije, molimo označite svoju e-poštu s „URGENT“ u naslovu i mi ćemo dati prioritet vašem zahtjevu.',
    },
    cta: {
      heading: "I dalje vam treba pomoć?",
      body: "Naš tim za podršku tu je za vas. Ne oklijevajte nas kontaktirati s bilo kakvim pitanjima ili nedoumicama.",
      button: "Pošaljite e-poštu podršci",
    },
  },
  advertising: {
    pageTitle: "Oglašavanje i monetizacija",
    seoTitle: "Oglašavanje — WasOK",
    seoDescription: "Kako WasOK pristupa oglašavanju i monetizaciji.",
    approach: {
      title: "Naš pristup",
      body: "U WasOK-u vjerujemo da su vaše navike kupovine i mišljenja o proizvodima privatni i osobni. Naš poslovni model odražava ovu temeljnu vrijednost.",
    },
    noAds: {
      title: "Bez oglasa",
      body: "WasOK ne prikazuje nikakve oglase. Nikada vam nećemo prikazivati oglase na temelju proizvoda koje skenirate, ocjena koje dajete ili bilo kojih drugih podataka koje kreirate u aplikaciji. Vaše iskustvo s WasOK-om potpuno je bez oglasa.",
    },
    noDataSelling: {
      title: "Bez prodaje podataka",
      body: "Ne prodajemo, ne iznajmljujemo niti dijelimo vaše podatke s oglašivačima, posrednicima podataka ili bilo kojim trećim stranama. Budući da su svi vaši podaci pohranjeni lokalno na vašem uređaju, mi im čak ni nemamo pristup. Vaše recenzije proizvoda, popisi za kupovinu i bilješke pripadaju samo vama.",
    },
    noTracking: {
      title: "Bez praćenja",
      body: "WasOK ne koristi piksele za praćenje, analitičke usluge ni bilo koju drugu tehnologiju koja nadzire vaše ponašanje ili dijeli informacije s trećim stranama. Ne pratimo koje proizvode skenirate, u kojim trgovinama kupujete ili kako koristite aplikaciju.",
    },
    sustainability: {
      title: "Kako ostajemo održivi",
      body: "Možda se pitate kako WasOK održavamo besplatnim bez oglasa ili prodaje podataka. Naš je pristup jednostavan:",
      items: [
        {
          label: "Besplatno i otvoreno:",
          text: "WasOK je besplatan za korištenje svima, bez premium razina ili plaćanja",
        },
        {
          label: "Racionalno poslovanje:",
          text: "Troškove držimo niskima izgradnjom učinkovitog softvera usmjerenog na privatnost",
        },
        {
          label: "Dobrovoljne donacije:",
          text: "Korisnici koji vole WasOK mogu nas podržati dobrovoljnim donacijama",
        },
        {
          label: "Otvoreni kod:",
          text: "Organizacijama možemo ponuditi usluge savjetovanja ili razvoja po mjeri",
        },
      ],
    },
    noAffiliate: {
      title: "Bez partnerskih poveznica",
      body: "WasOK ne koristi partnerske poveznice niti prima provizije od trgovaca. Kada skenirate proizvod, ne preusmjeravamo vas nikamo radi kupnje. Aplikacija služi isključivo za vaše osobno vođenje evidencije i donošenje odluka.",
    },
    noPromotions: {
      title: "Bez promocije proizvoda",
      body: "Ne primamo plaćanje od marki ili proizvođača za promociju njihovih proizvoda. WasOK vam nikada neće predlagati proizvode, isticati određene marke ili na bilo koji način utjecati na vaše ocjene. Vaša su mišljenja isključivo vaša.",
    },
    partnerships: {
      title: "Partnerstva s trećim stranama",
      body: "WasOK ne surađuje s marketinškim tvrtkama, agregatorima podataka ili oglašivačkim mrežama. Poslujemo neovisno i iznad svega dajemo prioritet vašoj privatnosti.",
    },
    future: {
      title: "Planovi za budućnost",
      body: "Predani smo tome da WasOK ostane bez oglasa i usmjeren na privatnost. Ako u budućnosti ikada budemo trebali uvesti održivi poslovni model, učinit ćemo sljedeće:",
      items: [
        "Objavit ćemo sve promjene dovoljno unaprijed",
        "Nikada nećemo ugroziti privatnost ili sigurnost podataka",
        "Uvijek ćemo ponuditi način korištenja aplikacije bez praćenja ili oglasa",
        "Slušat ćemo povratne informacije i zabrinutosti korisnika",
      ],
    },
    supporting: {
      title: "Podrška WasOK-u",
      body: "Ako volite WasOK i želite podržati našu misiju kupovnog pamćenja usmjerenog na privatnost, možete:",
      items: [
        "Reći svojim prijateljima i obitelji o aplikaciji",
        "Ostaviti pozitivnu recenziju na Google Play Storeu",
        "Podijeliti s nama svoje povratne informacije i prijedloge",
        "Razmisliti o dobrovoljnoj donaciji (kada je dostupna)",
      ],
    },
    cta: {
      heading: "Pitanja o našim pravilima?",
      body: "Transparentni smo u vezi s tim kako WasOK posluje. Ako imate bilo kakva pitanja o našem pristupu privatnosti, monetizaciji ili održivosti, obratite nam se.",
      button: "Kontaktirajte nas",
    },
  },
};
